<template>
    <div class="notification-item" :class="view">
        <div class="icon">
            <img src="@/assets/info-circle.svg"
            style="cursor: pointer;">
        </div>
        <div class="notiifcation-info-conteiner">
            <div class="notification-time flex column">
                <div class="notification-time">
                    Created at {{ renderTime(notification.datetime) }} by
                    <div class="user-name">
                        {{ notification.user_name }}
                    </div>
                </div>
                <div v-if="notification.handled_at" class='flex gap-5px'>
                    Handled at {{renderTime(notification.handled_at)}} by 
                    <div class="user-name">
                        {{ notification.handled_by_name }}
                    </div>
                </div>
            </div>
            <div class="notification-message">
                <div class="flex gap-4 wrap">
                    <div v-html="renderTitle(notification)"></div>
                    <div class="Result" v-if="notification.handled_by_name">
                        ({{ notification.actionTaken }})
                    </div>
                </div>

                <div class="flex gap-4 wrap" v-if="notification.fields || notification.fileInfo">
                    
                    <div v-if="notification.fileInfo" class="change-item">
                        New file uploaded
                    </div>
                    <div v-for="change in Object.keys(JSON.parse(notification.fields))" class="change-item ">
                        {{ Utils.fieldToName(change, notification) }}
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script setup>

import { ref, computed, onMounted, watch, defineEmits } from 'vue'

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime);
import { useStore } from 'vuex'
import Utils from '@/utils';
const store = useStore();
const user = computed(() => store.state.user);

const companyData = computed(() => store.state.companyData);
const props = defineProps(['notification', 'view'])


function renderTitle(action) {
    const companyType = companyData?.value?.company_type || action?.company_data?.company_type;
    let prefix = 'Following change(s) was/were made to the '
    if (action.actionType == 'remove') {
        prefix = 'Delete request for the '
    }

    if (action.subsidiary) {
        return prefix + '<b>Subsidiary</b>'
    }

    else if (action.kyc_file) {
        let text = prefix + '<b>' + Utils.typeToName(action.documentType) + '</b>'
        return text
    }

    else if (action.person) {
        let text = prefix + '<b>Individual</b> section'
        if (companyType == 'account_holder') {
            return prefix + '<b>Account Holder</b> section';
        }
        if (action.ubo_related) {
            text += ' in <b>UBO</b> section'
        }
        if (action.mbd_related) {
            return prefix + '<b>Official</b> in ' + '<b>Managing Director</b>'
        }
        return text
    }

    if (action.kyc_review) {
        if (action.actionType == 'remove') {
            if (companyType == 'account_holder') {
                return prefix + '<b>Account Holder</b> section'
            }
            return prefix + '<b>Corporate</b> section'
        } else {
            if (companyType == 'account_holder') {
                return prefix + '<b>Account Holder Dashboard</b> section'
            }
            return prefix + '<b>KYC Corporate Dashboard</b> section'
        }
    }
    else if (action.objectType == 'transaction_profile') {
        return prefix + '<b>Transaction Profile</b>'
    }

    else if (action.objectType == 'account_number') {
        return prefix + '<b>Account Number</b>'
    }

    else if (action.objectType == 'share_holder_related') {
        return prefix + '<b>Shareholder</b>'
    }

    else if (action.legalEntity) {
        if (action.share_holder_related) {
            return prefix + '<b>Corporate Shareholder</b>'
        }
        return (prefix + '<b>Legal Entity</b> in ' +  '<b>Managing Director</b>')
    }

    else if (action.ubo_related) {
        let text = prefix + '<b>UBO</b>'
        if (action.mbd_related) {
            text += ' for the Managing Director section'
        }
        return text
    }

    else if (action.mbd_related) {
        return (prefix + '<b>Managing Director</b> section')
    }
    
    else if (action.listingService) {
        return (prefix + '<b>Listing of services provided by trust service provider to company</b>')
    }
    else if (action.due_diligence_record) {
        return (prefix + '<b>Due Diligence Section</b>')
    }
    else if (action.due_diligence_element){
        return (prefix + '<b>Due Diligence Section</b>') 
    }
    else {
        return prefix + 'Unknown objects(' + (action.objectType) + ')'
    }
};




function renderTime(time) {
  return dayjs(time).format('MMM DD, YYYY [at] HH:mm');
}



</script>

<style scoped lang="scss">


.notification-view {
    border-radius: 10px;
    border: 1px solid var(--border-color);
    background-color: white;
    margin: auto;
    padding: 20px;
    margin: 20px 40px;
    margin-top: 80px;
}
.notification-item {
    border-bottom: 1px solid var(--border-color);
    padding: 20px;
    padding-left: 30px;
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
}
.forHistory {
    .change-item {
        background-color: #595b61;
        color: #f9f9f9;
    }
}
.notification-container {
    border-radius: 10px;
    border: 1px solid var(--border-color);
    background-color: white; 
}
.user-name {
    font-weight: bold;
    color: #595b61;
}
.notification-time {
    color: #74777F;
    font-size: 12px;
    display: flex;
    gap: 5px;
}
.notification-message {
    text-align: left;
    color: #181C22;
    font-size: 16px;
}
.notiifcation-info-conteiner {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
}
.time-relative {
    width: 100px;
    padding-right: 0;
}
.table-users {
    width: 100%;
    border-collapse: collapse;
    border-bottom: 1px solid #e6eaed;
}
.is-read-false {
    background: #f9f9f9;
}
td {
    padding: 10px 30px;
    text-align: left;
}
th {
    text-align: left;
    padding: 10px 30px;
    background: #E6EAED;
}
.preview {
    padding: 10px;
    cursor: pointer;
    width: 30px;
}

.icon {
    background-color: gray;
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(224 226 236);
    position: relative;
    &.is-read-false {
        &::after {
            content: '';
            position: absolute;
            right: 10px;
            top: 10px;
            left: -15px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: rgb(224 226 236);
    
        }

    }
}
.change-item {
    padding: 2px 12px;
    background-color: var(--primary-color);
    color: white;
    border-radius: 3px;
    width: fit-content;
}
.pagination {
    display: flex;
    gap: 10px;

  &:deep(li) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

  }
  &:deep(.paginate-buttons) {
    height: 40px;

    width: 40px;
   
    border-radius: 20px;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    color: black;
  }

  &:deep(.paginate-buttons:hover) {
    background-color: #d8d8d8;
  }

  &:deep(.active-page) {
    background-color: var(--primary-color);

    border: 1px solid var(--primary-color);

    color: white;
  }

  &:deep(.active-page:hover) {
    background-color: var(--primary-color);
  }
}

.notificaiton-read {
    width: 100%;
    text-align: right;
    cursor: pointer;
    text-decoration: underline;
}
</style>